import { Component, OnInit, Input } from '@angular/core';
@Component({
  selector: 'app-life-in-balance',
  templateUrl: './life-in-balance.component.html',
  styleUrls: ['./life-in-balance.component.scss']
})
export class LifeInBalanceComponent implements OnInit {

  @Input() childClass:string = '';
  @Input() isProdDesc:boolean;
  constructor() { }

  ngOnInit(): void {
          
  }

}
